import $ from 'jquery';
import slick from 'slick-carousel';

// import mousewheel from 'jquery-mousewheel';
import WOW from 'wow.js';

// import fancybox from '@fancyapps/fancybox';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
jQueryBridget('masonry', Masonry, $);

import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin( $ );

// import spectrum from 'spectrum-colorpicker';

import lazyload from '../bower_components/jieyou_lazyload/lazyload.min';

import validate from 'jquery-validation';
import layer from 'layui-layer';
import address from 'jquery-address';
import SimpleShare from './part/simple-share';

import anime from 'animejs/lib/anime.es.js';

// import moment from 'moment';
// import _, { map } from 'underscore';
// import clndr from 'clndr';

// import Modernizr from 'modernizr';
// import Modernizr from 'modernizr';
// import vidbg from '../bower_components/vidbg/vidbg.min';

// import 'jquery-datetimepicker/build/jquery.datetimepicker.min.css';
// import datetimepicker from 'jquery-datetimepicker';

$.validator.addMethod("isMobile", function(value, element) {  
    var length = value.length;  
    var mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/;  
    return this.optional(element) || (length == 11 && mobile.test(value));  
}, "手机号码格式不正确");

function getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

function scrollTo(id) {
    var d = $(id).offset().top - $('.header').height();
    $('html,body').stop().animate({
            scrollTop : d
    }, 'slow');
}

$(function(){

    // (function modernizr(){

    //     if (!Modernizr.promises) {
    //         // do ...
    //     }

    // })();


    (function header(){

        var $header = $('.header'),
            $body = $('body');

        $('.js-hs-btn').on('click', function(){
            $('.header-search').addClass('show');
            $body.addClass('search-open');
            $('.hs-input').focus();
        });
        $('.hs-input').on('blur', function(){
            $('.header-search').removeClass('show');
            $body.removeClass('search-open');
        });


        // Mobile menu button
        $('.js-menu-btn').on('click', function() {
            if ($('body').hasClass('menu-open')) {
                $('body').removeClass('menu-open');
            }else {
                $('body').addClass('menu-open');
            }
        });
        // console.log('d');

        // Fixed Menu
        $(window).on('scroll', function() {
            var winT = $(window).scrollTop();
            winT > 0 ? $body.addClass('fixed-menu') : $body.removeClass('fixed-menu')
        }).trigger('scroll');

    })();

    (function index(){
        if ($('.js-slick-ib').length) {

            var slickIb = $('.js-slick-ib').slick({
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                pauseOnHover: false
            });
            slickIb.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                $('.js-ib-pager span').removeClass('current');
                setTimeout(function(){
                    $('.js-ib-pager span').eq(nextSlide).addClass('current');
                }, 300);
            });
            $('.js-ib-pager span').on('mouseenter', function(){
                var index = $(this).index();
                slickIb.slick('slickGoTo', index);
                slickIb.slick('slickPause');
            });
            $('.js-ib-pager span').on('mouseleave', function(){
                slickIb.slick('slickPlay');
            });


            function changeBanner() {
                var winW = $(window).width();
                if (winW > 640) {
                    $('.js-ibanner').each(function() {
                        $(this).css({
                            'background-image': 'url('+$(this).attr('data-pc')+')'
                        })
                    });
                } else {
                    $('.js-ibanner').each(function() {
                        $(this).css({
                            'background-image': 'url('+$(this).attr('data-m')+')'
                        })
                    });
                }
            }
            changeBanner();
            $(window).on('resize', function(){
                changeBanner();
            });


            var slickIbnct = $('.js-slick-ibnct').slick({
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                pauseOnHover: false,
                lazyLoad: 'progressive'
            });
            slickIbnct.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                $('.ibnctab-item').removeClass('current');
                setTimeout(function(){
                    $('.ibnctab-item').eq(nextSlide).addClass('current');
                }, 10);
            });
            $('.ibnctab-item').on('click mouseenter', function(){
                var index = $(this).index();
                slickIbnct.slick('slickGoTo', index);
                slickIbnct.slick('slickPause');
            });
            $('.ibnctab-item').on('mouseleave', function(){
                slickIbnct.slick('slickPlay');
            });


            var slickIs = $('.js-slick-is').slick({
                arrows: false,
                dots: false,
                fade: true,
                autoplaySpeed: 3000,
                autoplay: true,
                // asNavFor: '.js-slick-iscd',
                lazyLoad: 'progressive',
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            fade: false
                        }
                    }
                ]
            });
            $('.js-iscb-line').css({
                width: $('.js-iscb-list > div').eq(0).width()
            });
            slickIs.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                $('.js-iscb-list > div').removeClass('current');
                setTimeout(function(){
                    $('.js-iscb-list > div').eq(nextSlide).addClass('current');
                    var bleft = $('.iscb-box').offset().left;
                    var left = $('.js-iscb-list > div').eq(nextSlide).offset().left;
                    var width = $('.js-iscb-list > div').eq(nextSlide).width();
                    $('.js-iscb-line').css({
                        left: left-bleft,
                        width: width
                    });
                }, 10);
            });
            $('.js-iscb-list > div').on('click mouseenter', function(){
                var index = $(this).index();
                slickIs.slick('slickGoTo', index);
                slickIs.slick('slickPause');
                // console.log('e');
                // $('.js-iscb-line').css({
                //     left: index*25+'%'
                // });
            });
            $('.js-iscb-list > div').on('mouseleave', function(){
                slickIs.slick('slickPlay');
            });
            var slickIsct = $('.js-slick-isct').slick({
                arrows: false,
                dots: false,
                fade: true,
                adaptiveHeight: false,
                autoplay: false,
            });
            // var slickIscd = $('.js-slick-iscd').slick({
            //     arrows: false,
            //     dots: false,
            //     fade: true,
            //     adaptiveHeight: false,
            //     autoplay: false
            // })
      
        }

        if ($('.js-bgVid').length) {
            $('.js-bgVid').each(function(index, item) {
                var video = $(item).attr('data-video');
                var id = $(item).attr('id');
                $(item).html('<div class="vidbg"><video autoplay="true" loop="loop" muted="muted" volume="0"><source src="'+video+'" type="video/mp4"></video><div class="vidbg-overlay"></div></div>');
            });

            // var winW = $(window).innerWidth();
            // var img = $('#bgVideo').attr('data-bg');
            // if (winW > 750) {
            //     vidbg(document.getElementById('bgVideo'), [
            //         {src: '/themes/cn/default/upload/video/index_video.mp4?sa', type: 'mp4'}
            //     ], true);
            // } else {
            //     $('#bgVideo').css({
            //         'background-image': 'url('+img+')',
            //         'background-color': '#fff'
            //     })
            // }
        }

        if ($('.js-inews-box').length) {
            

            $(window).on('scroll resize', function(){
                var inewT = $('.inews-box').offset().top;
                var inewL = $('.inews-box').offset().left;
                var winST = $(window).scrollTop();
                if (winST > (inewT - 140)) {
                    $('.js-inews-box').addClass('fixed');
                    $('.js-inews-box').css({
                        width: $('.inews-box').width()/2,
                        left: inewL
                    });
                } else {
                    $('.js-inews-box').removeClass('fixed');
                    $('.js-inews-box').css({
                        left: 'auto',
                        width: 'auto'
                    });
                }

                if (winST > $('.inews-box').offset().top + $('.inews-box').outerHeight() - 140 - $('.js-inews-box').outerHeight()) {
                    $('.js-inews-box').addClass('bottom');
                } else {
                    $('.js-inews-box').removeClass('bottom');
                }
            });
            $(window).on('resize', function(){

            });
        }

    })();

    (function team(){
        $('.js-team-tab > span').on('click', function(){
            $(this).addClass('current').siblings().removeClass('current');
            var index = $(this).index();
            $('.team-part').removeClass('active');
            $('.team-part').eq(index).addClass('active');
        });
        $('.js-team-cate > span').on('click mouseenter', function(){
            $(this).addClass('current').siblings().removeClass('current');
            var index = $(this).index();
            $('.team-cate-ul ul').removeClass('active');
            $('.team-cate-ul ul').eq(index).addClass('active');
        });
    })();

    (function contact(){
        $('.job-item__header').on('click', function() {
            var item = $(this).parents('.job-item');
            var body = item.find('.job-item__body');
            if (item.hasClass('show')) {
                item.removeClass('show');
                body.slideUp('fast');
            } else {
                item.addClass('show');
                body.slideDown('fast');
            }
        });
        if ($('#messageForm').length) {
            var isSubmit = true;
            var formObj = $('#messageForm');
            var btnSubmit = $('.js-msg-submit');
            formObj.validate({
                submitHandler: function(form) {
                    if ( isSubmit ) {
                        isSubmit = false;
                        var postURL = $(form).attr('action');
                        var postData = $(form).serialize();
                        $.ajax({
                            type: 'POST',
                            dataType: 'json',
                            url: postURL,
                            data: postData,
                            error: function(){
                                layer.msg('We encountered an error, please try again later!');
                                isSubmit = true;
                            },
                            success: function(res){
                                if ( res.success ) {
                                    layer.msg('Submitted successfully!');
                                    formObj[0].reset();
                                } else {
                                    layer.msg(res.info_cn);
                                }
                                isSubmit = true;
                            }
                        })
                    }
                },
                rules: {
                    name: {
                        required: true
                    },
                    tel: {
                        required: true,
                        isMobile: true
                    },
                    email: {
                        required: true,
                        email: true
                    },
                    msg: {
                        required: true
                    }
                },
                messages: {
                    name: {
                        required: 'Please fill in your name'
                    },
                    tel: {
                        required: 'Please fill in your mobile number'
                    },
                    email: {
                        required: 'please enter your email',
                        email: 'Email format error'
                    },
                    msg: {
                        required: 'Please fill in the message content'
                    }
                }
            });
            btnSubmit.on('click', function(){
                formObj.submit();
            });

        }

        if ($('.jobForm').length) {

            $('.js-mf-file').on('change', function(e){
                const name = e.target.files[0].name;
                // console.log(e.target.files, name);
                if (name) {
                    $(this).prev('label').html(name);
                }
            });

            $('.jobForm').each(function(index, item){
                
                    var formItem = item;
                    var isSubmit = true;
                    var formObj = $(formItem);
                    var btnSubmit = $(formItem).find('.js-jobform-btn');
                    formObj.validate({
                        submitHandler: function(form) {
                            if ( isSubmit ) {
                                isSubmit = false;
                                var postURL = $(form).attr('action');
                                var postData = new FormData(formObj[0]);
                                $.ajax({
                                    type: 'POST',
                                    dataType: 'json',
                                    url: postURL,
                                    data: postData,
                                    contentType:false,
                                    processData:false,
                                    error: function(){
                                        layer.msg('We encountered an error, please try again later!');
                                        isSubmit = true;
                                    },
                                    success: function(res){
                                        if ( res.success ) {
                                            layer.msg('Submitted successfully!');
                                            formObj[0].reset();
                                        } else {
                                            layer.msg(res.info);
                                        }
                                        isSubmit = true;
                                    }
                                })
                            }
                        },
                        rules: {
                            name: {
                                required: true
                            },
                            tel: {
                                required: true,
                                isMobile: true
                            },
                            email: {
                                required: true,
                                email: true
                            },
                            resume: {
                                required: true
                            }
                        },
                        messages: {
                            name: {
                                required: 'Please fill in your name'
                            },
                            tel: {
                                required: 'Please fill in your mobile number'
                            },
                            email: {
                                required: 'please enter your email',
                                email: 'Email format error'
                            },
                            resume: {
                                required: 'Please upload resume document'
                            }
                        }
                    });
                    btnSubmit.on('click', function(){
                        formObj.submit();
                    });
                });
            
        }
    })();

    (function front(){
        if ($('.js-grid-front').length) {
            var $gridMasonry,
                $gridBox = $('.js-grid-front');

            $gridBox.imagesLoaded(function() {
                
                $gridMasonry = $gridBox.masonry({
                    itemSelector: '.front-grid'
                });
                $gridMasonry.masonry('layout');
                
                setTimeout(function(){
                    $(window).trigger('resize');
                    $gridBox.removeClass('v-hide');
                }, 300);
            });
        } 
    })();

    (function about(){
        if ($('.js-slick-ahl').length) {
            var slickAhl = $('.js-slick-ahl').slick({
                arrows: false,
                dots: false,
                autoplay: false,
                fade: true,
                autoplaySpeed: 3000,
                asNavFor: '.js-slick-ahyear',
                pauseOnHover: false,
                lazyLoad: 'progressive'
            });

            var slickAhyear = $('.js-slick-ahyear').slick({
                arrows: false,
                dots: false,
                autoplay: true,
                variableWidth: true,
                autoplaySpeed: 3000,
                asNavFor: '.js-slick-ahl',
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 641,
                        settings: {
                            arrows: true,
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            variableWidth: false
                        }
                    }
                ]
            });

            slickAhl.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                $('.ahry-item').removeClass('current');
                setTimeout(function(){
                    $('.ahry-item').eq(nextSlide).addClass('current');
                }, 10);
            });
            $('.ahry-item').on('click mouseenter', function(){
                $(this).addClass('current').siblings().removeClass('current');
                var index = $(this).index();
                slickAhl.slick('slickGoTo', index);
            });
        }

        // map
        if ($('.js-global-img').length) {
            // console.log('line');
            for (var i = 1;i < 8;i++) {
                var path = anime.path('.st'+i);
                anime({
                    targets: '.circle'+i,
                    translateX: path('x'),
                    translateY: path('y'),
                    rotate: path('angle'),
                    easing: 'linear',
                    duration: 3000,
                    loop: true
                });
            }


            $(window).on('scroll', function() {

                if ($(window).scrollTop() > $('.js-global-img').offset().top - $(window).height() && $(window).scrollTop() < $('.js-global-img').offset().top) {
                    $('.js-global-img').addClass('show');
                }

                
                
                // $('.map-line').find('.path').each(function(index, item){
                //     console.log('.st'+(index+1)+'+'+$(item).attr('class')+'{stroke-dashoffset: '+parseInt($(item)[0].getTotalLength())+';}');
                // });
                
                // $('.line-item').each(function(index, item){
                //     console.log('.st'+(index+1)+'{fill:none;stroke:#FFC72F;stroke-dasharray: '+Math.ceil($(item).find('path')[0].getTotalLength())+';}')
                // })
                // tl.staggerTo('.circle1', 1.2, {attr: {r: 32}, yoyo: true}, .15);

            });
            
            // var len = $('.md-item').length;
            // var i = 0;
            // setInterval(() => {
            //     var circle = '.'+$('.md-item').eq(i).find('circle').eq(0).attr('class');
            //     var tl = new TimelineMax();
            //     tl.set(circle, {attr: {r: 17, opacity: 0}});
            //     tl.to(circle, 1, {attr: {r: 26, opacity: .194}});
            //     tl.to(circle, 1, {attr: {r: 32, opacity: 0}});
            //     tl.set(circle, {attr: {r: 17, opacity: .194}});
            //     tl.to(circle, 1, {attr: {r: 26, opacity: .194}});
            //     tl.to(circle, 1, {attr: {r: 32, opacity: 0}});
            //     tl.set(circle, {attr: {r: 17, opacity: 0}});
            //     i++;
            //     if (i > len) {
            //         i = 0;
            //     }
            // }, 4500);

        }
    })();

    (function cases(){
        if ($('.js-slick-cases').length) {
            var slickCases = $('.js-slick-cases').slick({
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                fade: true,
                pauseOnHover: true,
                lazyLoad: 'progressive'
            });
            slickCases.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                $('.js-slick-case-pager span').removeClass('current');
                setTimeout(function(){
                    $('.js-slick-case-pager span').eq(nextSlide).addClass('current');
                }, 10);
            });
            $('.js-slick-case-pager span').on('mouseenter', function(){
                var index = $(this).index();
                slickCases.slick('slickGoTo', index);
                slickCases.slick('slickPause');
            });
            $('.js-slick-case-pager span').on('mouseleave', function(){
                slickCases.slick('slickPlay');
            });
        }
        if ($('.js-slick-caseg').length) {
            var slickCaseg = $('.js-slick-caseg').slick({
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                pauseOnHover: true,
                lazyLoad: 'progressive'
            });
            slickCaseg.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                $('.casesgl-item').removeClass('current');
                setTimeout(function(){
                    $('.casesgl-item').eq(nextSlide).addClass('current');
                }, 100);
            });
            $('.casesgl-item').on('mouseenter', function(){
                var index = $(this).index();
                slickCaseg.slick('slickGoTo', index);
                slickCaseg.slick('slickPause');
            });
            $('.casesgl-item').on('mouseleave', function(){
                slickCaseg.slick('slickPlay');
            });
        }

        $('.case-item__more').on('mouseenter', function(){
            $(this).parents('.case-item').addClass('show');
        });
        $('.case-item__more').on('mouseleave', function(){
            $(this).parents('.case-item').removeClass('show');
        });


        if ($('.js-slick-borond').length) {

            $(window).on('resize', function() {
                setTimeout(function(){
                    $('.js-boron-item-02').css({
                        height: $('.js-boron-item-01').height()
                    })
                }, 1000);
            }).trigger('resize');
            

            var slickBorond = $('.js-slick-borond').slick({
                arrows: false,
                dots: false,
                fade: true,
                autoplay: true,
                autoplaySpeed: 3000,
                pauseOnHover: false,
                asNavFor: '.js-slick-boronimg'
            });
            slickBorond.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                $('.js-boron-tip > span').removeClass('current');
                setTimeout(function(){
                    $('.js-boron-tip > span').eq(nextSlide).addClass('current');
                }, 100);
            });
            $('.js-boron-tip > span').on('click mouseenter', function(){
                var index = $(this).index();
                slickBorond.slick('slickGoTo', index);
            });

            var slickBorondImg = $('.js-slick-boronimg').slick({
                arrows: false,
                dots: false,
                autoplaySpeed: false,
                asNavFor: '.js-slick-borond',
                lazyLoad: 'progressive'
            })
        }

        if ($('.waves').length) {
            if (Modernizr.proxy) {
                class ShaderProgram {

                    constructor( holder, options = {} ) {
                
                    options = Object.assign( {
                        antialias: false,
                        depthTest: false,
                        mousemove: false,
                        autosize: true,
                        side: 'front',
                        vertex: `
                        precision highp float;
                
                        attribute vec4 a_position;
                        attribute vec4 a_color;
                
                        uniform float u_time;
                        uniform vec2 u_resolution;
                        uniform vec2 u_mousemove;
                        uniform mat4 u_projection;
                
                        varying vec4 v_color;
                
                        void main() {
                
                            gl_Position = u_projection * a_position;
                            gl_PointSize = (10.0 / gl_Position.w) * 100.0;
                
                            v_color = a_color;
                
                        }`,
                        fragment: `
                        precision highp float;
                
                        uniform sampler2D u_texture;
                        uniform int u_hasTexture;
                
                        varying vec4 v_color;
                
                        void main() {
                
                            if ( u_hasTexture == 1 ) {
                
                            gl_FragColor = v_color * texture2D(u_texture, gl_PointCoord);
                
                            } else {
                
                            gl_FragColor = v_color;
                
                            }
                
                        }`,
                        uniforms: {},
                        buffers: {},
                        camera: {},
                        texture: null,
                        onUpdate: ( () => {} ),
                        onResize: ( () => {} ),
                    }, options )
                
                    const uniforms = Object.assign( {
                        time: { type: 'float', value: 0 },
                        hasTexture: { type: 'int', value: 0 },
                        resolution: { type: 'vec2', value: [ 0, 0 ] },
                        mousemove: { type: 'vec2', value: [ 0, 0 ] },
                        projection: { type: 'mat4', value: [ 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1 ] },
                    }, options.uniforms )
                
                    const buffers = Object.assign( {
                        position: { size: 3, data: [] },
                        color: { size: 4, data: [] },
                    }, options.buffers )
                
                    const camera = Object.assign( {
                        fov: 60,
                        near: 1,
                        far: 10000,
                        aspect: 1,
                        z: 100,
                        perspective: true,
                    }, options.camera )
                
                    const canvas = document.createElement( 'canvas' )
                    const gl = canvas.getContext( 'webgl', { antialias: options.antialias } )
                
                    if ( ! gl ) return false
                
                    this.count = 0
                    this.gl = gl
                    this.canvas = canvas
                    this.camera = camera
                    this.holder = holder
                    this.onUpdate = options.onUpdate
                    this.onResize = options.onResize
                    this.data = {}
                
                    holder.appendChild( canvas )
                
                    this.createProgram( options.vertex, options.fragment )
                
                    this.createBuffers( buffers )
                    this.createUniforms( uniforms )
                
                    this.updateBuffers()
                    this.updateUniforms()
                
                    this.createTexture( options.texture )
                
                    gl.enable( gl.BLEND )
                    gl.enable( gl.CULL_FACE )
                    gl.blendFunc( gl.SRC_ALPHA, gl.ONE )
                    gl[ options.depthTest ? 'enable' : 'disable' ]( gl.DEPTH_TEST )
                
                    if ( options.autosize )
                        window.addEventListener( 'resize', e => this.resize( e ), false )
                    if ( options.mousemove )
                        window.addEventListener( 'mousemove', e => this.mousemove( e ), false )
                
                    this.resize()
                
                    this.update = this.update.bind( this )
                    this.time = { start: performance.now(), old: performance.now() }
                    this.update()
                
                    }
                
                    mousemove( e ) {
                
                    let x = e.pageX / this.width * 2 - 1
                    let y = e.pageY / this.height * 2 - 1
                
                    this.uniforms.mousemove = [ x, y ]
                
                    }
                
                    resize( e ) {
                
                    const holder = this.holder
                    const canvas = this.canvas
                    const gl = this.gl
                
                    const width = this.width = holder.offsetWidth
                    const height = this.height = holder.offsetHeight
                    const aspect = this.aspect = width / height
                    const dpi = this.dpi = devicePixelRatio
                
                    canvas.width = width * dpi
                    canvas.height = height * dpi
                    canvas.style.width = width + 'px'
                    canvas.style.height = height + 'px'
                
                    gl.viewport( 0, 0, width * dpi, height * dpi )
                    gl.clearColor( 0, 0, 0, 0 )
                
                    this.uniforms.resolution = [ width, height ]
                    this.uniforms.projection = this.setProjection( aspect )
                
                    this.onResize( width, height, dpi )
                
                    }
                
                    setProjection( aspect ) {
                
                    const camera = this.camera
                
                    if ( camera.perspective ) {
                
                        camera.aspect = aspect
                
                        const fovRad = camera.fov * ( Math.PI / 180 )
                        const f = Math.tan( Math.PI * 0.5 - 0.5 * fovRad )
                        const rangeInv = 1.0 / ( camera.near - camera.far )
                
                        const matrix = [
                        f / camera.aspect, 0, 0, 0,
                        0, f, 0, 0,
                        0, 0, (camera.near + camera.far) * rangeInv, -1,
                        0, 0, camera.near * camera.far * rangeInv * 2, 0
                        ]
                
                        matrix[ 14 ] += camera.z
                        matrix[ 15 ] += camera.z
                
                        return matrix
                
                    } else {
                
                        return [
                        2 / this.width, 0, 0, 0,
                        0, -2 / this.height, 0, 0,
                        0, 0, 1, 0,
                        -1, 1, 0, 1,
                        ]
                
                    }
                
                    }
                
                    createShader( type, source ) {
                
                    const gl = this.gl
                    const shader = gl.createShader( type )
                
                    gl.shaderSource( shader, source )
                    gl.compileShader( shader )
                
                    if ( gl.getShaderParameter (shader, gl.COMPILE_STATUS ) ) {
                
                        return shader
                
                    } else {
                
                        // console.log( gl.getShaderInfoLog( shader ) )
                        gl.deleteShader( shader )
                
                    }
                
                    }
                
                    createProgram( vertex, fragment ) {
                
                    const gl = this.gl
                
                    const vertexShader = this.createShader( gl.VERTEX_SHADER, vertex )
                    const fragmentShader = this.createShader( gl.FRAGMENT_SHADER, fragment )
                
                    const program = gl.createProgram()
                
                    gl.attachShader( program, vertexShader )
                    gl.attachShader( program, fragmentShader )
                    gl.linkProgram( program )
                
                    if ( gl.getProgramParameter( program, gl.LINK_STATUS ) ) {
                
                        gl.useProgram( program )
                        this.program = program
                
                    } else {
                
                        // console.log( gl.getProgramInfoLog( program ) )
                        gl.deleteProgram( program )
                
                    }
                
                    }
                
                    createUniforms( data ) {
                
                    const gl = this.gl
                    const uniforms = this.data.uniforms = data
                    const values = this.uniforms = {}
                
                    Object.keys( uniforms ).forEach( name => {
                
                        const uniform = uniforms[ name ]
                
                        uniform.location = gl.getUniformLocation( this.program, 'u_' + name )
                
                        Object.defineProperty( values, name, {
                        set: value => {
                
                            uniforms[ name ].value = value
                            this.setUniform( name, value )
                
                        },
                        get: () => uniforms[ name ].value
                        } )
                
                    } )
                
                    }
                
                    setUniform( name, value ) {
                
                    const gl = this.gl
                    const uniform = this.data.uniforms[ name ]
                
                    uniform.value = value
                
                    switch ( uniform.type ) {
                        case 'int': {
                        gl.uniform1i( uniform.location, value )
                        break
                        }
                        case 'float': {
                        gl.uniform1f( uniform.location, value )
                        break
                        }
                        case 'vec2': {
                        gl.uniform2f( uniform.location, ...value )
                        break
                        }
                        case 'vec3': {
                        gl.uniform3f( uniform.location, ...value )
                        break
                        }
                        case 'vec4': {
                        gl.uniform4f( uniform.location, ...value )
                        break
                        }
                        case 'mat2': {
                        gl.uniformMatrix2fv( uniform.location, false, value )
                        break
                        }
                        case 'mat3': {
                        gl.uniformMatrix3fv( uniform.location, false, value )
                        break
                        }
                        case 'mat4': {
                        gl.uniformMatrix4fv( uniform.location, false, value )
                        break
                        }
                    }
                
                    // ivec2       : uniform2i,
                    // ivec3       : uniform3i,
                    // ivec4       : uniform4i,
                    // sampler2D   : uniform1i,
                    // samplerCube : uniform1i,
                    // bool        : uniform1i,
                    // bvec2       : uniform2i,
                    // bvec3       : uniform3i,
                    // bvec4       : uniform4i,
                
                    }
                
                    updateUniforms() {
                
                    const gl = this.gl
                    const uniforms = this.data.uniforms
                
                    Object.keys( uniforms ).forEach( name => {
                
                        const uniform = uniforms[ name ]
                
                        this.uniforms[ name ] = uniform.value
                
                    } )
                
                    }
                
                    createBuffers( data ) {
                
                    const gl = this.gl
                    const buffers = this.data.buffers = data
                    const values = this.buffers = {}
                
                    Object.keys( buffers ).forEach( name => {
                
                        const buffer = buffers[ name ]
                
                        buffer.buffer = this.createBuffer( 'a_' + name, buffer.size )
                
                        Object.defineProperty( values, name, {
                        set: data => {
                
                            buffers[ name ].data = data
                            this.setBuffer( name, data )
                
                            if ( name == 'position' )
                            this.count = buffers.position.data.length / 3
                
                        },
                        get: () => buffers[ name ].data
                        } )
                
                    } )
                
                    }
                
                    createBuffer( name, size ) {
                
                    const gl = this.gl
                    const program = this.program
                
                    const index = gl.getAttribLocation( program, name )
                    const buffer = gl.createBuffer()
                
                    gl.bindBuffer( gl.ARRAY_BUFFER, buffer )
                    gl.enableVertexAttribArray( index )
                    gl.vertexAttribPointer( index, size, gl.FLOAT, false, 0, 0 )
                
                    return buffer
                
                    }
                
                    setBuffer( name, data ) {
                
                    const gl = this.gl
                    const buffers = this.data.buffers
                
                    if ( name == null && ! gl.bindBuffer( gl.ARRAY_BUFFER, null ) ) return
                
                    gl.bindBuffer( gl.ARRAY_BUFFER, buffers[ name ].buffer )
                    gl.bufferData( gl.ARRAY_BUFFER, new Float32Array( data ), gl.STATIC_DRAW )
                
                    }
                
                    updateBuffers() {
                
                    const gl = this.gl
                    const buffers = this.buffers
                
                    Object.keys( buffers ).forEach( name =>
                        buffers[ name ] = buffer.data
                    )
                
                    this.setBuffer( null )
                
                    }
                
                    createTexture( src ) {
                
                    const gl = this.gl
                    const texture = gl.createTexture()
                
                    gl.bindTexture( gl.TEXTURE_2D, texture )
                    gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array( [ 0, 0, 0, 0 ] ) )
                
                    this.texture = texture
                
                    if ( src ) {
                
                        this.uniforms.hasTexture = 1
                        this.loadTexture( src )
                
                    }
                
                    }
                
                    loadTexture( src ) {
                
                    const gl = this.gl
                    const texture = this.texture
                
                    const textureImage = new Image()
                
                    textureImage.onload = () => {
                
                        gl.bindTexture( gl.TEXTURE_2D, texture )
                
                        gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImage )
                
                        gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR )
                        gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR )
                
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
                
                        // gl.generateMipmap( gl.TEXTURE_2D )
                
                    }
                
                    textureImage.src = src
                
                    }
                
                    update() {
                
                    const gl = this.gl
                
                    const now = performance.now()
                    const elapsed = ( now - this.time.start ) / 5000
                    const delta = now - this.time.old
                    this.time.old = now
                
                    this.uniforms.time = elapsed
                
                    if ( this.count > 0 ) {
                        gl.clear( gl.COLORBUFFERBIT )
                        gl.drawArrays( gl.POINTS, 0, this.count )
                    }
                
                    this.onUpdate( delta )
                
                    requestAnimationFrame( this.update )
                
                    }
                
                }
                
                const pointSize = 2.5
                
                const waves = new ShaderProgram( document.querySelector( '.waves' ), {
                    texture: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMAC/goGvDhmwcExrVjWzrm29TRqqSKenRXVklANSIUE8mRkGpv+HOfAAABCElEQVQ4y4VT13LDMAwLrUHteO+R9f/fWMfO6dLaPeKVEECRxOULWsEGpS9nULDwia2Y+ALqUNbAWeg775zv+sA4/FFRMxt8U2FZFCVWjR/YrH4/H9sarclSKdPMWKzb8VsEeHB3m0shkhVCyNzeXeAQ9Xl4opEieX2QCGnwGbj6GMyjw9t1K0fK9YZunPXeAGsfJtYjwzxaBnozGGorYz0ypK2HzQSYx1y8DgSRo2ewOiyh2QWOEk1Y9OrQV0a8TiBM1a8eMHWYnRMy7CZ4t1CmyRkhSUvP3gRXyHOCLBxNoC3IJv//ZrJ/kxxUHPUB+6jJZZHrpg6GOjnqaOmzp4NDR48OLxn/H27SRQ08S0ZJAAAAAElFTkSuQmCC',
                    uniforms: {
                    size: { type: 'float', value: pointSize },
                    field: { type: 'vec3', value: [ 0, 0, 0 ] },
                    speed: { type: 'float', value: 5 },
                    },
                    vertex: `
                    #define M_PI 3.1415926535897932384626433832795
                
                    precision highp float;
                
                    attribute vec4 a_position;
                    attribute vec4 a_color;
                
                    uniform float u_time;
                    uniform float u_size;
                    uniform float u_speed;
                    uniform vec3 u_field;
                    uniform mat4 u_projection;
                
                    varying vec4 v_color;
                
                    void main() {
                
                        vec3 pos = a_position.xyz;
                
                        pos.y += (
                        cos(pos.x / u_field.x * M_PI * 8.0 + u_time * u_speed) +
                        sin(pos.z / u_field.z * M_PI * 8.0 + u_time * u_speed)
                        ) * u_field.y;
                
                        gl_Position = u_projection * vec4( pos.xyz, a_position.w );
                        gl_PointSize = ( u_size / gl_Position.w ) * 100.0;
                
                        v_color = a_color;
                
                    }`,
                    fragment: `
                    precision highp float;
                
                    uniform sampler2D u_texture;
                
                    varying vec4 v_color;
                
                    void main() {
                
                        gl_FragColor = v_color * texture2D(u_texture, gl_PointCoord);
                
                    }`,
                    onResize( w, h, dpi ) {
                
                    const position = [], color = []
                
                    const width = 400 * ( w / h )
                    const depth = 400
                    const height = 3
                    const distance = 5
                
                    for ( let x = 0; x < width; x += distance ) {
                        for ( let z = 0; z < depth; z+= distance ) {
                
                        position.push( - width / 2 + x, -30, -depth / 2 + z )
                        color.push( 0, 1 - ( x / width ) * 1, 0.5 + x / width * 0.5, z / depth )
                
                        }
                    }
                
                    this.uniforms.field = [ width, height, depth ]
                
                    this.buffers.position = position
                    this.buffers.color = color
                
                    this.uniforms.size = ( h / 400) * pointSize * dpi
                
                    },
                })
            }
        }
        
    })();

    (function ajaxLoding(){
        if ($('.js-ajax-list').length) {
            var pagerBox = $('.ajax-page');
            var btnLoading = $('.js-btn-loading');
            var ajaxPosition = $('.js-ajax-position')
            var isLoading = true;
            var $gridTest = $('.js-ajax-html');
            $(window).on('scroll resize', function(){
                const winH = $(window).height();
                const sTop = $(window).scrollTop();
                const oTop = ajaxPosition.offset().top;
                if (winH + sTop >= oTop) {
                    loadList();
                }
            });
            function loadList() {
                if (isLoading) {
                    isLoading = false;
                    var url = $('.ajax-page').find('.page-next').attr('href');
                    if (url) {
                        $.ajax({
                            type: 'get',
                            url: url,
                            beforeSend: function(){
                                btnLoading.fadeIn();
                            },
                            success: function(data){
                                var ajaxListHTML = $(data).find('.js-ajax-list').html();
                                var ajaxPagerHTML = $(data).find('.ajax-page').html();
                                $gridTest.html(ajaxListHTML);
                                pagerBox.html(ajaxPagerHTML);

                                $gridTest.imagesLoaded(function() {
                                    $('.js-ajax-list').append($gridTest.html());
                                    isLoading = true;
                                    btnLoading.fadeOut('slow');
                                    $(".lazy").lazyload({
                                        effect : "fadeIn",
                                        threshold: 1000
                                    });
                                });
                            }
                        });
                    } else {
                        btnLoading.fadeOut('slow');
                    }
                    
                }
                
            }
        }
    })();

    // Video Layer
    (function layerVideo(){
        $('.js-btn-play').on('click', function(){
            var video = $(this).attr('data-video');
            var videoHTML = '<div class="layer-video"><div class="layer-video-bg js-video-bg"></div><div class="layer-video-wrap"><video autoplay controls controlslist="nodownload" loop><source src="'+video+'" type="video/mp4"></video><div class="layer-video-close js-video-close icon-close"></div></div></div>';
            $('body').append(videoHTML);
        });
        $(document).on('click', '.js-video-close, .js-video-bg', function(){
            $('.layer-video').remove();
        });
    })();

    (function footer(){

        // Back to top button
        $('.js-gotop').on('click', function(){
            $('html,body').stop().animate({
                    scrollTop : 0
            }, 'slow');
        });
        

        $(window).on('scroll', function() {
            if ($(window).scrollTop() > $(window).height()) {
                $('.js-gotop').fadeIn();
            } else {
                $('.js-gotop').fadeOut();
            }
        });
        
    })();

    // Init Function
    (function init(){

        function goPage() {
            var id = getQueryVariable('s');
            if (id != '') {
                if (document.getElementById(id)) {
                    scrollTo('#'+id);
                }
            }
        }

        // Scroll to the specified position
        goPage();
        $(window).on('load', function(){
            goPage();
        });

        // image lazyload
        $(".lazy").lazyload({
            effect : "fadeIn",
            threshold: 1000
        });

        // Disable right-click menu
        // $(document).on("contextmenu",function(e){
        //     return false;
        // });

        new WOW().init();
        
        // Social Share
        var share = new SimpleShare({
            url: '',
            title: '',
            content: '',
            pic: ''
        });
        $('.social a').on('click', function () {
            var type = $(this).attr('data-share');
        
            switch (type){
                case 'twitter':
                    share.twitter();
                    break;
                case 'facebook':
                    share.facebook();
                    break;
                case 'linkedin':
                    share.linkedin();
                    break;
                case "weixin":
                    share.weixin();
                    break;
                case "weibo":
                    share.weibo();
                    break;
                case 'tumblr':
                    share.tumblr();
                    break;
                case 'pinterest':
                    share.pinterest();
                    break;
                default:
                    break;
            }
        });
        $(document).on('click', '.js-wxClose', function(){
            $('.wx-share').remove();
        });
    })();

});